import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiX, FiPackage, FiShoppingCart } from 'react-icons/fi';
import './OrderTypeModal.scss';

const OrderTypeModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSelectPreOrder = (source) => {
    navigate('/system/ventas/nueva-preorden', { state: { source } });
    onClose();
  };

  const handleSelectStandardOrder = () => {
    navigate('/system/ventas/nueva-orden');
    onClose();
  };

  return (
    <div className="order-type-modal-overlay" onClick={onClose}>
      <div className="order-type-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FiX size={24} />
        </button>

        <div className="modal-header">
          <h2 className="modal-title">¿Qué tipo de orden deseas crear?</h2>
          <p className="modal-subtitle">Selecciona el tipo de orden según tu necesidad</p>
        </div>

        <div className="modal-body">
          <div className="order-type-cards">
            {/* PRE-ORDEN Card */}
            <div className="order-type-card order-type-card--preorder">
              <div className="card-icon">
                <FiPackage size={48} />
              </div>
              <h3 className="card-title">PRE-ORDEN</h3>
              <p className="card-description">
                Para producción interna y toma de pedidos semanales
              </p>

              <div className="card-divider"></div>

              <div className="card-sources">
                <p className="sources-label">Selecciona la fuente:</p>
                <button
                  className="source-btn source-btn--betel"
                  onClick={() => handleSelectPreOrder('BETEL_NATURAL')}
                >
                  <span className="source-icon">🌿</span>
                  Betel Natural
                </button>
                <button
                  className="source-btn source-btn--lab"
                  onClick={() => handleSelectPreOrder('NATURALAND_LAB')}
                >
                  <span className="source-icon">🧪</span>
                  Naturaland Lab
                </button>
                <button
                  className="source-btn source-btn--viernes"
                  onClick={() => handleSelectPreOrder('BETEL_NATURAL_VIERNES')}
                >
                  <span className="source-icon">📅</span>
                  Betel Natural Viernes
                </button>
              </div>
            </div>

            {/* ORDEN/COTIZACIÓN Card */}
            <div className="order-type-card order-type-card--standard">
              <div className="card-icon">
                <FiShoppingCart size={48} />
              </div>
              <h3 className="card-title">ORDEN / COTIZACIÓN</h3>
              <p className="card-description">
                Para ventas comerciales estándar y cotizaciones a clientes
              </p>

              <div className="card-divider"></div>

              <div className="card-features">
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Gestión completa de clientes</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Cálculo automático de totales</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Direcciones de facturación y entrega</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span>Generación de facturas</span>
                </div>
              </div>

              <button
                className="select-btn"
                onClick={handleSelectStandardOrder}
              >
                Crear Orden o Cotización
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTypeModal;
